<div class="input-content-form-input-content-list validateform">
  <ul role="list" [formGroup]="formGroup" style="list-style-type:none;padding: 0;">
    <li *ngFor="let inputContent of inputContents; let i = index" [class.d-none]="inputContent.isHidden">
      <answer-type-field [inputContent]="inputContent" [formGroup]="formGroup" class="w-100">
      </answer-type-field>
    </li>
  </ul>
</div>